import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {DrugInteractionCategoryDTO} from 'src/app/modules/pbm/models/DrugInteractionCategoryDTO';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {PagedResponseDTO} from 'src/app/modules/common/models/PagedResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class DrugInteractionCategoryService {

  private url = environment.baseUrl + '/drug-interaction-category';

  constructor(private httpClient: HttpClient) {
  }

  getListOfDrugInteractionCategories(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<DrugInteractionCategoryDTO>> {
    return this.httpClient.post<PagedResponseDTO<DrugInteractionCategoryDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveDrugInteractionCategory(drugInteractionCategoryDTO: DrugInteractionCategoryDTO): Observable<DrugInteractionCategoryDTO> {
    return this.httpClient.post<DrugInteractionCategoryDTO>(this.url, drugInteractionCategoryDTO);
  }

  deleteDrugInteractionCategory(drugInteractionCategoryId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + drugInteractionCategoryId);
  }

  getDrugInteractionCategory(drugInteractionCategoryId: number): Observable<DrugInteractionCategoryDTO> {
    return this.httpClient.get<DrugInteractionCategoryDTO>(this.url + '/' + drugInteractionCategoryId);
  }
}
